export default __webpack_public_path__ + "static/media/killer_gf_02.303cb265.jpg";